export default{border:"S",px:"L",py:"M",radius:"M",shadow:"NONE"};
